__turbopack_context__.v({
  "container": "CrossFade-module__ABp9nq__container",
  "crossFade": "CrossFade-module__ABp9nq__crossFade",
  "hidden": "CrossFade-module__ABp9nq__hidden",
});
